<template>
    <div class="dashboard-page bold tablec">
        <div class="d-flex flex-row">
            <Widget title="Notifications" class="w-100" :fetchingData="isReceiving || isDeleting">
                <b-button variant="success" @click="$router.push(`/app/content/notifications/create`)" v-if="hasAdminRole()"
                          class="mb-3 mt-3">
                    Create new notification
                </b-button>

                <div class="table-resposive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>Message</th>
                            <th class="hidden-sm-down">Visibility</th>
                            <th class="hidden-sm-down">Send to all</th>
                            <th class="hidden-sm-down">Recurrence UM</th>
                            <th class="hidden-sm-down">Start date</th>
                            <th class="hidden-sm-down">End date</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="row in notifications" :key="row.id">
                            <td>{{row.message.length > 20 ? row.message.substring(0,20) + '...' : row.message}}</td>
                            <td>{{row.public}}</td>
                            <td>{{row.sendToAll}}</td>
                            <td>{{row.recurrenceUM}}</td>
                            <td>{{row.recurrenceUM == 'Once' ? formatStringDatetime(row.startTime) : formatDate(row.startDate, row.timezone)}}</td>
                            <td>{{row.recurrenceUM == 'Once' ? '' : formatDate(row.endDate, row.timezone)}}</td>
                            <td>
                                <b-button-toolbar v-if="hasAdminRole(row.global)">
                                    <b-button variant="info" size="xs" @click="$router.push('/app/content/notifications/' + row.id)">
                                        <span class="d-none d-md-inline-block">Edit</span>
                                        <span class="d-md-none"><i class='la la-edit'></i></span>
                                    </b-button>
                                    <b-button :id="'popoverDelete_' + row.id" variant="danger" size="xs">
                                        <Loader v-if="isDeleting" :size="14"/>
                                        <span v-else>
                              <span class="d-none d-md-inline-block">Delete</span>
                              <span class="d-md-none"><i class='la la-remove'></i></span>
                            </span>
                                    </b-button>
                                    <b-popover class="popover-danger"
                                               triggers="focus"
                                               :target="'popoverDelete_' + row.id"
                                               :show.sync="popovers[row.id]"
                                               placement="top"
                                    >
                                        <template slot="title">
                                            <div class="px-5">Are you sure</div>
                                        </template>
                                        <div class="px-5 d-flex justify-content-center">
                                            <b-button-toolbar>
                                                <b-button variant="success" size="xs" @click="deleteNotificationRequest({id:row.id, $toasted})">
                                                    Yes
                                                </b-button>
                                                <b-button variant="danger" size="xs" @click="closePopover(row.id)">
                                                    No
                                                </b-button>
                                            </b-button-toolbar>
                                        </div>
                                    </b-popover>
                                </b-button-toolbar>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </Widget>
        </div>
    </div>
</template>

<script>
  import Loader from "../../components/Loader/Loader";
  import {mapActions, mapState} from "vuex";
  import Widget from "../../components/Widget/Widget";
  import vSelect from "vue-select";
  import moment from "moment";
  import {firestore} from "../../main";

  export default {
    name: "Notifications",
    components: {Loader, Widget, vSelect},
    computed: {
      ...mapState("auth", ["currentUser"]),
      ...mapState("countries", ["selectedCountry", "countries"]),
      ...mapState("notifications", ["notifications", "isReceiving", "isDeleting"]),
    },
    data() {
      return {
        user: JSON.parse(localStorage.getItem('user') || {}),
        showAdminActions: false,
        popovers: {},
      };
    },
    watch:{
      selectedCountry: function (val) {
        this.getNotificationsRequest(val.id);
        this.fetchCurrentUser();
        if(this.currentUser != null) {
          const countryCode = val.code;
          const userAuthorities = this.currentUser.userAuthorities;
          const adminAuthorities = userAuthorities.filter(a => a.role == 'ROLE_ROOT'
            || (a.role == 'ROLE_USER' && countryCode === a.tenantCode))
          if(adminAuthorities.length > 0){
            this.showAdminActions = true;
          }
        }
      },
      currentUser: function (val) {
      }
    },
    methods: {
      ...mapActions("notifications", ["getNotificationsRequest", "deleteNotificationRequest"]),
      ...mapActions("auth", ["fetchCurrentUser"]),
      formatDate(date, timezone){
          return date ? moment.unix(date['seconds']).tz(timezone ? timezone : this.selectedCountry.timezone).format('MMMM Do YYYY') : '';
      },
      formatStringDatetime(date){
        return date ? moment(date).format('MMMM Do YYYY HH:mm') : '';
      },
      closePopover(id) {
        this.popovers[id] = false;
      },
      hasAdminRole(isGlobal){
        const user = this.currentUser ? this.currentUser : this.user;
        if(user && this.countries && this.selectedCountry) {
          const selectedCountryId = this.selectedCountry.id;
          const selectedCountry = this.countries.filter(c => c.id == selectedCountryId )
          if (selectedCountry && selectedCountry.length > 0) {
            const countryData = selectedCountry[0];
            const userAuthorities = user.userAuthorities;
            const adminAuthorities = userAuthorities.filter(a => (a.role == 'ROLE_ADMIN' && countryData.code === a.tenantCode));
            const rootAuthorities = userAuthorities.filter(a => a.role == 'ROLE_ROOT');

            if (rootAuthorities.length > 0 || (adminAuthorities.length > 0 && !isGlobal)) {
              return true;
            }
          }
        }
      },
    },
    async mounted() {

      if(this.currentUser == undefined || this.currentUser.id == null) {
        await this.fetchCurrentUser();
      }
      if(this.currentUser && this.currentUser.selectedCountryId){
        this.getNotificationsRequest(this.currentUser.selectedCountryId);
      }
    }
  }
</script>

<style scoped/>
